import Vue from 'vue';
import store from 'store';

export default (el) =>
  new Vue({
    components: {
      tabs: () => import('./tabs.vue'),
      tab: () => import('./tab.vue'),
    },
    el,
    store,
    name: 'How to',
  });
